import { parseISO } from "date-fns";

export const isJobInPast = (job: {
  id: string;
  title: string | null;
  shifts?: {
    id: string;
    startsAt: Date | string;
    endsAt: Date | string;
  }[];
}): boolean => {
  if (!job.shifts || job.shifts.length === 0) {
    return false;
  }

  const latestDate = job.shifts
    .map((shift) => {
      const endsAt = shift.endsAt;
      return typeof endsAt === "string" ? parseISO(endsAt) : endsAt;
    })
    .reduce((latest, current) => (current > latest ? current : latest));

  return latestDate < new Date();
};
